import { Close } from '@mui/icons-material';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, TextField } from '@mui/material';
import React, { useState } from 'react'
import ChefForPartyService from '../../services/ChefForPartyService';
import EventBus from '../../EventBus';
import { EventBusEventsEnum } from '../../enums/EventBusEventsEnum';
import { CustomSnackbarTypes } from './CustomSnackBar';
import { DateTimePicker } from '@mui/x-date-pickers';
import moment from 'moment';



interface InputProps {
    data: any;
    open: boolean;
    callBack: () => void;
    partyDate: string;
}


let chefForPartyService = new ChefForPartyService();

function PartyCookExtraDetails(props: InputProps) {
    let[extraDetails,setExtraDetails] = useState<any>({
        cookCut: props?.data?.cookCut || '0',
        helperCost: props?.data?.helperCost || '0',
        travelAllowance: props?.data?.travelAllowance || '0',
        extraTimePayment: props?.data?.extraTimePayment || '0',
        arrivalTime: `${props?.partyDate} ${props?.data?.arrivalTime}` || null,
        staysTill: `${props?.partyDate} ${props?.data?.staysTill}` || null,
    });
    const handleClose = () => {
        props.callBack();
    };

    const handleSubmit = () => {
        const payload:any  = {};
        if(extraDetails.cookCut) {
            payload['cookCut'] = extraDetails.cookCut;
        }
        if(extraDetails.helperCost) {
            payload['helperCost'] = extraDetails.helperCost;
        }
        if(extraDetails.travelAllowance) {
            payload['travelAllowance'] = extraDetails.travelAllowance;
        }
        if(extraDetails.extraTimePayment) {
            payload['extraTimePayment'] = extraDetails.extraTimePayment;
        }
        if(extraDetails.arrivalTime){
            payload['arrivalTime'] = moment(
                extraDetails.arrivalTime
            ).format("YYYY-MM-DD HH:mm:ss");
        }
        if(extraDetails.staysTill){
              payload['staysTill'] = moment(
                extraDetails.staysTill
            ).format("YYYY-MM-DD HH:mm:ss");
        }
            payload['cookDetailsId'] = props?.data?.id;
        if(Object.keys(payload).length === 0) {
            return;
        }

        chefForPartyService.updateChefForPartyCookExtraDetails(props?.data?.chefForPartyId, props?.data?.cookId ,payload).then(() => {
            props.callBack();
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: `Cook Extra Details Updated Successfully`,
                type: CustomSnackbarTypes.SUCCESS,
            });
            setExtraDetails({
                cookCut: '',
                helperCost: '',
                travelAllowance: '',
                extraTimePayment: '',
                staysTill: null,
                arrivalTime: null
            });
            window.location.reload();
        }).catch((err) => {
            console.error(err);
            setExtraDetails({
                cookCut: '',
                helperCost: '',
                travelAllowance: '',
                extraTimePayment: '',
                staysTill: null,
                arrivalTime: null
            });
            props.callBack();
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: `Failed to update Cook Extra Details`,
                type: CustomSnackbarTypes.ERROR,
            });
        });
    }


  return (
    <Dialog onClose={handleClose} open={props.open} scroll={"paper"} maxWidth="xl">
            <DialogTitle>Update Cook Extra Details</DialogTitle>
            <DialogContent sx={{minWidth: '340px'}}>
              <IconButton onClick={handleClose} sx={{ position: 'absolute', top: 8, right: 8 }}> <Close /> </IconButton>
              <FormControl fullWidth>
                <TextField label={'Enter Cook Cut'} onChange={(e: any) => {
                    setExtraDetails({...extraDetails, cookCut: e.target.value});
                }} value={extraDetails.cookCut} />
                <TextField label={'Enter Helper Cost'} onChange={(e: any) => {
                  setExtraDetails({...extraDetails, helperCost: e.target.value});
                }} value={extraDetails.helperCost} />
                <TextField label={'Enter Travel Allowance'} onChange={(e: any) => {
                    setExtraDetails({...extraDetails, travelAllowance: e.target.value});
                }} value={extraDetails.travelAllowance}/>
                <TextField label={'Enter Extra Time Payment'} onChange={(e: any) => {
                    setExtraDetails({...extraDetails, extraTimePayment: e.target.value});
                }} value={extraDetails.extraTimePayment} />
                <span style={{fontStyle: 'italic', color:"red"}}>* Not Necessary to fill these fields</span>
                <DateTimePicker
                    label="Arrival Time"
                    value={extraDetails.arrivalTime}
                    onChange={(newValue) => {
                        setExtraDetails({ ...extraDetails, arrivalTime: newValue });
                    }}
                    renderInput={(params) => <TextField {...params} />}
                />
                <DateTimePicker
                    label="Vendor Stays Till Time"
                    value={extraDetails.staysTill}
                    onChange={(newValue) => {
                        setExtraDetails({ ...extraDetails, staysTill: newValue });
                    }}
                    renderInput={(params) => <TextField {...params} />}
                />
              </FormControl>
            </DialogContent>
            <DialogActions>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    size={"large"}>
                    Submit
                </Button>
                <Button
                    variant="contained"
                    color={"error"}
                    onClick={() => { handleClose(); }}
                    size={"large"} >
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>
  )
}

export default PartyCookExtraDetails
